import Vue from 'vue';

export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/app/utils/event-bus.js